<template>
  <div class="dropdown d-inline ">
    <button id="filterDate" type="button" class='btn mb-0 btn-outline-primary dropdown-toggle ms-2'
      data-bs-toggle="dropdown" :aria-expanded="true" :class="[isSelected ? 'active-filter' : '']">Fecha</button>

    <div id="body-dropdown" class="dropdown-menu" aria-labelledby="filterDate" style="min-width: 250px;">
      <form ref="formDate" class="px-4 py-3 .needs-validation">
        <div class="mb-3">
          <label class="form-label">Fecha Inicio <span style="color:red">*</span> </label>
          <input v-model="localDates.start" class="form-control" type="date" required @change="handleClick()" @input="validateDateField($event)"/>
          <div id="start-date-message" class="invalid-feedback">
                Fecha no puede estar vacio
          </div>
        </div>
        <div class="mb-3">
          <label class="form-label">Fecha Fin <span style="color:red">*</span> </label>
          <input v-model="localDates.end" class="form-control" type="date" required @change="handleClick()" @input="validateDateField($event)"/>
          <div id="end-date-message" class="invalid-feedback">
                Fecha no puede estar vacio
          </div>
        </div>
      </form>
      <hr class="horizontal my-2" />
      <button class="dropdown-item border-radius-md text-danger" type="button" @click="cleanFilters('')">Limpiar
        filtros</button>
    </div>
  </div>
</template>
<script>
export default {
  name: "FilterDate",
  components: {},
  props: {
    valueDate: {
      type: Object,
      default: () => {
        return {
          start: '',
          end:''
        }
      },
    },
  },
  emits: ['filter-change', 'input','clean-filter-date'],
  data() {
    return {
      localDates: this.valueDate
    }
  },
  computed: {
    isSelected() {
      return this.localDates.start!= '' || this.localDates.end !='';
    }
  },
  watch: {
    localDates(newValue) {
      this.$emit("input", newValue);
    },
    valueDate(newValue) {
      this.localDates = newValue;
    },
  },
  methods: {
    cleanFilters() {
      this.$emit('clean-filter-date')
      this.close();
    },
    close() {
      document.getElementById("filterDate").click();
      // let dropdownBody = document.getElementById("body-dropdown");
      // dropdownBody.classList.remove('show');
    },
    handleClick() {
      let form = this.$refs.formDate;
      if(form.checkValidity() ){
        this.$emit('filter-change', this.localDates);
      }
    },
    validateDateField($event){
      let value = $event.target.value;
      let form = this.$refs.formDate;
      if(value==''){
        $event.target.classList.add("is-invalid")
        form.classList.remove('was-validated')
        return
      }
      $event.target.classList.remove("is-invalid")
    }

  },
}
</script>
<style scoped>
.active {
  background-color: rgb(234, 244, 247) !important;
}

.active-filter {
  color: #fff;
  background-color: #344767;
  border-color: #344767;
}
.dropdown-menu {
  width:100%;
}
.was-validated .form-control:invalid, .form-control.is-invalid {
  background-position: right 1.3rem center !important;
}
</style>